// App.js
import React from "react";
import TodoApp from "./TodoApp";
import { TodoProvider } from "./Store";

function App() {
  return (
    <TodoProvider>
      <TodoApp />
    </TodoProvider>
  );
}

export default App;
